export const validEmail = (text) => {
  // eslint-disable-next-line no-useless-escape
  let reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return reg.test(text);
};

export const validNumber = (text) => {
  let reg = /^[0-9]+$/g;
  return reg.test(text);
};

export class Utility {
  static fcmToken = '';
  static isAlertShowing = false;

  static updateAlertShowing(to) {
    if (to === false) {
      setTimeout(() => {
        Utility.isAlertShowing = false;
      }, 5000);
      return;
    }
    Utility.isAlertShowing = to;
  }
}

export const checkOffline = () => {
  return !window.navigator.onLine;
};

export const getNameInitials = (name) => {
  // name = name.toUpperCase()
  if (name && typeof name === 'string' && name !== '' && name.length > 0) {
    // let nameArray = name.split(" ");
    // if (nameArray.length <= 1) return nameArray[0][0];
    // else return nameArray[0][0] + nameArray[1][0];
    let userName = name;
    if (userName.includes(' ')) {
      var nameString = userName.split(' ');
      if (
        nameString[0].slice(0, 1) === undefined ||
        nameString[0].slice(0, 1) === NaN
      ) {
        if (
          nameString[1].slice(0, 1) === undefined ||
          nameString[1].slice(0, 1) === NaN
        ) {
          return '' + '';
        } else {
          return '' + nameString[1].slice(0, 1);
        }
      } else if (
        nameString[1].slice(0, 1) === undefined ||
        nameString[1].slice(0, 1) === NaN
      ) {

        return nameString[0].slice(0, 1) + '';
      } else {

        return nameString[0].slice(0, 1) + nameString[1].slice(0, 1);
      }
    } else {
      let first = userName.slice(0, 1);
      if (first === undefined || first === NaN) {

      } else {

        return first;
      }
    }
  } else {
    return '';
  }
};
